// src/components/MasterDataModal.js
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './MasterDataModal.css'; 

function MasterDataModal({ isOpen, onClose, onSave, record, setRecord, isEditing, vendors, agents, mode }) {
  const [selectedVendorId, setSelectedVendorId] = useState('');

  // Sync selectedVendorId when editing in API mode
  useEffect(() => {
    if (isOpen && mode === 'api' && record.agent_id && agents) {
      const agentObj = agents.find(a => a.id === parseInt(record.agent_id));
      if (agentObj) {
        setSelectedVendorId(agentObj.vendor_id.toString());
      }
    } else if (isOpen && mode === 'api' && !record.agent_id) {
      setSelectedVendorId('');
    }
  }, [isOpen, record.agent_id, agents, mode]);

  if (!isOpen) {
    return null;
  }

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setRecord(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleVendorChange = (e) => {
    const val = e.target.value;
    setSelectedVendorId(val);
    setRecord(prev => ({ ...prev, agent_id: '' }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave();
  };

  const filteredAgents = mode === 'api' && agents 
    ? agents.filter(a => a.vendor_id.toString() === selectedVendorId) 
    : [];

  // Bungkus seluruh JSX dengan ReactDOM.createPortal
  return ReactDOM.createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <h2>{isEditing ? 'Edit Record' : 'Add New Record'}</h2>
        <form onSubmit={handleSubmit}>

          {mode === 'api' ? (
            <>
              <div className="form-group">
                <label>Vendor</label>
                <select value={selectedVendorId} onChange={handleVendorChange} required>
                  <option value="">-- Select Vendor --</option>
                  {vendors && vendors.map(v => (
                    <option key={v.id} value={v.id}>{v.name}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Agent</label>
                <select name="agent_id" value={record.agent_id || ''} onChange={handleChange} required disabled={!selectedVendorId}>
                  <option value="">-- Select Agent --</option>
                  {filteredAgents.map(a => (
                    <option key={a.id} value={a.id}>{a.name}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>PGA Name</label>
                <input name="pga_name" value={record.pga_name || ''} onChange={handleChange} required />
              </div>

              <div className="form-group">
                <label>Project</label>
                <input name="project" value={record.project || ''} onChange={handleChange} />
              </div>

              <div className="form-group">
                <label>Base URL</label>
                <input name="base_url" value={record.base_url || ''} onChange={handleChange} required placeholder="https://api.example.com" />
              </div>

              <div className="form-group" style={{ display: 'flex', gap: '10px' }}>
                <div style={{ flex: 1 }}>
                  <label>Provider ID (Legacy)</label>
                  <input name="provider_id" value={record.provider_id || ''} onChange={handleChange} />
                </div>
                <div style={{ flex: 1 }}>
                  <label>Merchant ID (Legacy)</label>
                  <input name="merchant_id" value={record.merchant_id || ''} onChange={handleChange} />
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="form-group">
                <label>PGA Name</label>
                <input name="pga_name" value={record.pga_name || ''} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label>Vendor</label>
                <input name="vendor" value={record.vendor || ''} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label>Project</label>
                <input name="project" value={record.project || ''} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Agent</label>
                <input name="agent" value={record.agent || ''} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Base URL</label>
                <input name="base_url" value={record.base_url || ''} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Platform</label>
                <input name="platform" value={record.platform || ''} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Provider ID</label>
                <input name="provider_id" value={record.provider_id || ''} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Merchant ID</label>
                <input name="merchant_id" value={record.merchant_id || ''} onChange={handleChange} />
              </div>
            </>
          )}

          <div className="form-group-toggle">
            <label>Is Active</label>
            <label className="switch">
              <input type="checkbox" name="is_active" checked={record.is_active !== false} onChange={handleChange} />
              <span className="slider round"></span>
            </label>
          </div>
          <div className="modal-actions">
            <button type="button" onClick={onClose}>Cancel</button>
            <button type="submit">Save</button>
          </div>
        </form>
      </div>
    </div>,
    document.getElementById('modal-root')
  );
}

export default MasterDataModal;